module.exports = __webpack_public_path__ + "img/fyt_p4.d6aa93d3.png";